import React, { useState, useEffect } from "react";
import { BadgeCheck, Activity, Archive } from "lucide-react";
import { Purchasedplan } from "../../CommonAPI/User";
import Swal from "sweetalert2";
import Content from '../../../ExtraComponent/Content';

const MyPurchasedPlans = () => {
  const username = localStorage.getItem("name");
  const [plans, setPlans] = useState({ loading: true, active: [], expired: [] });
  const [tabIndex, setTabIndex] = useState("0");

  const formatDateForInput = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const [fromDate, setFromDate] = useState(
    formatDateForInput(new Date(new Date().setMonth(new Date().getMonth() - 1)))
  );
  const [toDate, setToDate] = useState(formatDateForInput(new Date()));

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const req = { From_date: fromDate, To_date: toDate, Username: username };
        const response = await Purchasedplan(req);
        if (response.Status) {
          setPlans({
            loading: false,
            active: response.ActivePlan,
            expired: response.ExpiredPlan,
          });
        } else {
          setPlans({ loading: false, active: [], expired: [] });
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
        Swal.fire({
          title: "Error",
          text: "Failed to fetch plans.",
          icon: "error",
          timer: 1500,
          timerProgressBar: true,
        });
        setPlans({ loading: false, active: [], expired: [] });
      }
    };
    fetchPlans();
  }, [username, fromDate, toDate]);

  const renderPlans = (plansData) => {
    return plansData.length > 0 ? (
      <div className="row">
        {plansData.map((plan, index) => {
          const hasChartingSignal = plan?.ChartingSignal?.length > 0;
          return (
            <div className="col-md-4 mb-4" key={index}>
              <div className="card h-100 shadow-sm">
                <div className="card-body d-flex flex-column">
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="card-title mb-0">{plan.Planname}</h5>
                    <BadgeCheck size={22} color="#4caf50" />
                  </div>
                  <hr />
                  {/* Details */}
                  {plan?.NumberofScript > 0 && (
                    <p className="mb-2"><strong>📑 No of Scripts:</strong> {plan?.NumberofScript}</p>
                  )}
                  {hasChartingSignal ? (
                    <>
                      <p className="mb-2"><strong>Charting Signal:</strong> {plan?.ChartingSignal?.join(", ")}</p>
                      <p className="mb-2"><strong>Start Date:</strong> {plan?.StartDate}</p>
                      <p className="mb-2"><strong>End Date:</strong> {plan?.EndDate}</p>
                    </>
                  ) : (
                    <>
                      <p className="mb-2"><strong>Scalping Strategy:</strong> {plan?.Scalping?.join(", ")}</p>
                      <p className="mb-2"><strong>Option Strategy:</strong> {plan?.["Option Strategy"]?.join(", ")}</p>
                      <p className="mb-2"><strong>Pattern Strategy:</strong> {plan?.Pattern?.join(", ")}</p>
                      <p className="mb-2"><strong>Start Date:</strong> {plan?.StartDate}</p>
                      <p className="mb-2"><strong>End Date:</strong> {plan?.EndDate}</p>
                    </>
                  )}
                  {/* Footer */}
                  <button className="btn modern-btn mt-auto" disabled>
                    Purchased <BadgeCheck size={18} style={{ marginLeft: 6 }} />
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    ) : (
      <p>No Plans Found</p>
    );
  };

  return (
    <Content Page_title={"📉 MyPlan"} button_status={false} backbutton_status={false}>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item active " aria-current="page">My Purchased Plans</li>
        </ol>
      </nav>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <a
            className={`nav-link ${tabIndex === "0" ? "active" : ""}`}
            onClick={() => setTabIndex("0")}
          >
           Active Plans
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${tabIndex === "1" ? "active" : ""}`}
            onClick={() => setTabIndex("1")}
          >
             Expired Plans
          </a>
        </li>
      </ul>

      {/* Date Filters */}
      <div className="card card-body mb-3">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">To Date</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Tab Content */}
      {tabIndex === "0" && (plans.loading ? <p>Loading...</p> : renderPlans(plans.active))}
      {tabIndex === "1" && (plans.loading ? <p>Loading...</p> : renderPlans(plans.expired))}
    </Content>
  );
};

export default MyPurchasedPlans;
